import List from 'list.js';

export function friendsList() {
  const list = document.querySelector('.friends-archive');
  if(!list) return;

  const friendsListInstance = new List(list, {
    valueNames: [
      { name: 'name', attr: 'data-name' },
      { name: 'location', attr: 'data-name' },
      'search-text'
    ]
  });

  const countEl = document.querySelector('.friends-count');
  const updateCount = function() {
    if(countEl) {
      const visibleCount = friendsListInstance.visibleItems.length;
      const tpl = (typeof fabfLabels !== 'undefined' && fabfLabels.friendsCount) ? fabfLabels.friendsCount : '%d';
      countEl.textContent = tpl.replace('%d', visibleCount);
    }
  };

  const updateMapVisibility = function() {
    if(typeof window.setFriendsMapVisibility !== 'function') return;
    const ids = new Set();
    friendsListInstance.visibleItems.forEach((item) => {
      const trigger = item.elm.querySelector('[data-friends-id]');
      if(trigger && trigger.dataset.friendsId) ids.add(String(trigger.dataset.friendsId));
    });
    window.setFriendsMapVisibility(ids);
  };

  const onListChange = function() {
    updateCount();
    updateMapVisibility();
  };

  friendsListInstance.on('searchComplete', onListChange);
  friendsListInstance.on('filterComplete', onListChange);

  friendsListInstance.sort('name', { order: 'asc' });
  const nameSort = list.querySelector('.sort[data-sort="name"]');
  if(nameSort) nameSort.classList.add('asc');

  const normalize = function(str) {
    return (str || '').normalize('NFKC').toLowerCase();
  };

  const searchInput = list.querySelector('.search-input');
  if(searchInput) {
    searchInput.addEventListener('input', function() {
      const query = normalize(this.value.trim());
      if(!query) {
        friendsListInstance.filter();
        friendsListInstance.search();
        onListChange();
        return;
      }
      friendsListInstance.filter(function(item) {
        return normalize(item.values()['search-text']).indexOf(query) !== -1;
      });
      onListChange();
    });
  }

  // View toggle
  const viewToggles = list.querySelectorAll('.view-toggle');
  const listEl = list.querySelector('.list');
  const STORAGE_KEY = 'friends-view';

  const setView = function(view) {
    if(!listEl) return;
    listEl.classList.remove('view-list', 'view-grid');
    listEl.classList.add('view-' + view);
    viewToggles.forEach(function(t) {
      t.classList.toggle('active', t.dataset.view === view);
    });
    try { localStorage.setItem(STORAGE_KEY, view); } catch(e) {}
  };

  viewToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      setView(this.dataset.view);
    });
  });
}
